import React, { useEffect, useState } from 'react';
import CategoryModal from '../components/CategoryModal';

function Main({ onSelect, onClose, initialSelectedCategoryId, initialSelectedSubcategoryId }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const frame = requestAnimationFrame(() => setVisible(true));
        return () => cancelAnimationFrame(frame);
    }, []);

    const handleClose = () => {
        setVisible(false);
        setTimeout(onClose, 280);
    };

    return (
        <div className="fixed inset-0 z-[1000] flex">
            {/* Dark overlay */}
            <div
                className={`absolute inset-0 bg-black transition-opacity duration-300 cursor-pointer ${visible ? 'opacity-50' : 'opacity-0'}`}
                onClick={handleClose}
            />

            {/* Sliding panel */}
            <div
                className={`relative h-full w-full md:w-[480px] bg-white shadow-2xl flex flex-col transition-transform duration-300 ease-out ${visible ? 'translate-x-0' : '-translate-x-full'}`}
            >
                <CategoryModal
                    onSelect={onSelect}
                    onClose={handleClose}
                    initialSelectedCategoryId={initialSelectedCategoryId}
                    initialSelectedSubcategoryId={initialSelectedSubcategoryId}
                />
            </div>
        </div>
    );
}

export default Main;
